import { readonly, ref, type Ref } from 'vue'
import type { ApiClient } from '@fusapp-work/api'
import { useCurrentSession } from './useCurrentSession'

export interface UseSessionLogout {
  readonly isPending: Readonly<Ref<boolean>>
  readonly hasError: Readonly<Ref<boolean>>
  signOut(): Promise<void>
}

export function useSessionLogout(apiClient: ApiClient, navigateToLogin: () => Promise<unknown>): UseSessionLogout {
  const isPending = ref(false)
  const hasError = ref(false)

  async function signOut(): Promise<void> {
    if (isPending.value) return
    isPending.value = true
    hasError.value = false
    try {
      // Cosmos ucu uygulama çerezini temizler ve 204 döner.
      // Microsoft oturumunu kapatmaz veya farklı bir Entra hesabı seçtirmez.
      const response = await apiClient.request<unknown>('/api/v1/auth/logout', { method: 'POST' })
      if (response !== undefined) throw new Error('Expected a no-content logout response')
      useCurrentSession().reset()
      await navigateToLogin()
    } catch {
      hasError.value = true
    } finally {
      isPending.value = false
    }
  }

  return { isPending: readonly(isPending), hasError: readonly(hasError), signOut }
}
